'use client'

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion'
import { ChevronRight } from 'lucide-react'
import { useId } from 'react'

function slugifyQuestion(text) {
  return String(text)
    .toLowerCase()
    .trim()
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}

export function FaqAccordion({ children, type = 'single', collapsible = true, className = '' }) {
  return (
    <Accordion type={type} collapsible={collapsible} className={`faq-accordion ${className}`.trim()}>
      {children}
    </Accordion>
  )
}

export function FaqItem({ question, children }) {
  const value = useId()
  const anchorId = slugifyQuestion(question)

  return (
    <AccordionItem value={value} className="faq-item" id={anchorId}>
      <div className="faq-item__header w-full [&>h3]:w-full">
        <AccordionTrigger className="faq-item__trigger w-full">
          <span className="faq-item__trigger-row">
            <ChevronRight className="faq-item__chevron" />
            <span className="faq-item__question">{question}</span>
          </span>
        </AccordionTrigger>
        {/* <a
          href={`#${anchorId}`}
          className="faq-item__anchor"
          aria-label={`Link to ${question}`}
          onClick={(event) => {
            event.stopPropagation()
          }}
        >
          <Link2 className="faq-item__anchor-icon" />
        </a> */}
      </div>
      <AccordionContent className="faq-item__content pt-4!">{children}</AccordionContent>
    </AccordionItem>
  )
}
